exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-window[data-v-2ae52b32] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 9999999;\n  background-color: rgba(0, 0, 0, 0.5);\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  padding: 2rem;\n}\n.modal-window.show[data-v-2ae52b32] {\n  visibility: visible;\n  opacity: 1;\n  pointer-events: auto;\n}\n.modal-window .modal-content[data-v-2ae52b32] {\n  height: 100%;\n}\n", ""]);

// exports
